import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Joins class names, resolving Tailwind conflicts in favour of the last one.
 *
 * `clsx` handles the conditionals; `twMerge` makes the last conflicting utility
 * win, so a component's own `px-4` can be overridden by a caller's `px-8`
 * without needing `!important` or prop-specific escape hatches.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
